module.exports = __webpack_public_path__ + "models/tribrach.da1497c5.gltf";